import { useState, useCallback } from 'react';

/**
 * Custom hook to manage code transition animations
 * Handles selection, deselection, and search highlighting animations
 */
export default function useCodeTransitions() {
  // Track current transition for animation (only one at a time)
  // Include timestamp to prevent re-animation on virtualization scroll
  const [activeTransition, setActiveTransition] = useState(null);

  // Clear any active transition
  const clearTransition = useCallback(() => {
    setActiveTransition(null);
  }, []);

  // Set a transition for a specific code
  const setTransition = useCallback((codeId, type) => {
    if (!codeId || !type) return;
    
    setActiveTransition({ 
      codeId,
      type,
      timestamp: Date.now()
    });
  }, []);

  // Handle selection transition
  const setSelectionTransition = useCallback((codeId, isSelected) => {
    if (!codeId) return;
    
    const type = isSelected ? 'deselect' : 'select';
    setTransition(codeId, type);
  }, [setTransition]);

  // Handle search disabled transition (yellow fade)
  const setSearchDisabledTransition = useCallback((codeId) => {
    if (!codeId) return;
    
    setTransition(codeId, 'search-disabled');
  }, [setTransition]);

  return {
    activeTransition,
    clearTransition,
    setSelectionTransition,
    setSearchDisabledTransition
  };
}